<div class="hrmParent">
  <div class="hrm" [style.backgroundImage]="'url(/assets/images/hrz'+zone+'.png)'"></div>
  <div class="hrmIndex" [style.transform]="'rotate('+angle+'deg)'"></div>
  <div class="hrmStats">
    <h1>{{codes[zone]}}</h1>
    <h2>{{avgHeart| number:'1.0-0'}}</h2>
    <ion-icon name="heart" [class]="'hrm'+zone"></ion-icon>
  </div>
</div>
